import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme, useMediaQuery } from "@mui/material";
import { OutlinedInput } from "@mui/material";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import "dayjs/locale/es";
import Select from "@mui/material/Select";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Divider from "@mui/material/Divider";
import Chip from "@mui/material/Chip";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import HomeIcon from "@mui/icons-material/Home";
import DeleteIcon from "@mui/icons-material/Delete";
import NoteAddOutlinedIcon from "@mui/icons-material/NoteAddOutlined";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import Backdrop from "@mui/material/Backdrop";
import Restricted from "components/Restricted";
import CircularProgress from "@mui/material/CircularProgress";
import Autocomplete from "@mui/material/Autocomplete";
import { IMaskInput } from "react-imask";
import clienteAxios from "../../config/clienteAxios";
import axios from "axios";
// --- NUEVA IMPORTACIÓN ---
import FormHelperText from "@mui/material/FormHelperText";
import DiagnosticosV2 from "./components/DiagnosticosV2";
import GruposEnfermedadV2 from "./components/GruposEnfermedadV2";
import {
  SALUD_CLINICA_V2_ENDPOINT,
  buildSaludV2Payload,
  buildSaludV2Request,
  canEditSaludV2,
  createEmptyDiagnosisV2,
  extractApiErrorV2,
  getStoredUser,
  normalizeDiagnosisV2,
  normalizeMedicationV2,
  normalizeSaludV2Response,
  safeJsonParse,
  validateDiagnosesV2,
  validateSaludV2FieldLimits,
} from "./saludClinicaV2Utils";

function Item(props) {
  const { sx, ...other } = props;
  return (
    <Box
      sx={{
        p: 1,
        m: 1,
        fontSize: "0.875rem",
        fontWeight: "700",
        ...sx,
      }}
      {...other}
    />
  );
}

Item.propTypes = {
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="+00(#00) 000-0000"
      definitions={{
        "#": /[0-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const options = {
  smooth: true,
};

const EditarSaludV2 = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const token = params.get("prop");
  const proyect = safeJsonParse(token, {});
  const recordId = params.get("id") || proyect.id;
  const tipoActividad = "";


  const nav = useNavigate();

  // --- ESTADO PARA ERRORES ---
  const [errors, setErrors] = useState({});

  // --- FUNCIÓN PARA LIMPIAR ERRORES ---
  const clearError = (fieldName) => {
    if (errors[fieldName]) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };

  const motivosDesdeServidor = {
    motivoConsulta1: proyect.motivoConsulta1,
    motivoConsulta2: proyect.motivoConsulta2,
    motivoConsulta3: proyect.motivoConsulta3,
    motivoConsulta4: proyect.motivoConsulta4,
    motivoConsulta5: proyect.motivoConsulta5,
  };
  const motivosArray = [];
  for (let i = 1; i <= 5; i++) {
    const motivo = motivosDesdeServidor[`motivoConsulta${i}`];
    if (motivo !== null && motivo !== undefined && motivo !== "") {
      motivosArray.push({ motivoConsulta: motivo });
    }
  }
  const [items, setItems] = React.useState(getStoredUser);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("token"));
    if (items) {
      setItems(items);
    }
  }, []);

  const rol = items.rol;

  //Theme
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");

  function handleClickBreadCrumbs(event) {
    event.preventDefault();
  }

  //DatePicker Value
  const [fechaNacSalud, setFechaNacSalud] = React.useState(
    proyect.fecha_nacimiento
  );
  const [valueResp, setValueResp] = React.useState(null);
  const [fechaActSalud, setFechaActSalud] = React.useState(
    proyect.fecha_evaluacion
  );

  //Modal Handlers
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  //Motivo de Consulta Input
  const [data, setData] = useState(
    motivosArray.length > 0 ? motivosArray : [{ motivoConsulta: "" }]
  );
  const [activar, setActivar] = useState(true);
  const [actDelete, setActDelete] = useState(true);
  let contador = 0;
  let contadorDelete = 0;

  const handleClick = () => {
    setData([...data, { motivoConsulta: "" }]);
    setActivar(true);
    setActDelete(true);
  };
  const handleChangeInput = (e, i) => {
    const { name, value } = e.target;
    const onchangeVal = [...data];
    onchangeVal[i][name] = value;
    setData(onchangeVal);
    clearError("motivoConsulta");
    let hasEmptyField = onchangeVal.some(
      (item) => item.motivoConsulta.trim() === ""
    );
    setActivar(hasEmptyField);
  };
  const handleDelete = (i) => {
    const deleteVal = [...data];
    deleteVal.splice(i, 1);
    setData(deleteVal);
  };

  //Diagnostico Inputs
  const [diagnosticos, setDiagnosticos] = useState([createEmptyDiagnosisV2()]);

  //Routes
  const handleLinkCancelar = (event, message) => {
    if (message === "cancelar") {
      nav(-1);
    }
  };

  const handleLinkHome = (event, message) => {
    if (message === "home") {
      nav("/inicio");
    }
  };

  const handleLinkTranscripcion = (event, message) => {
    if (message === "transcripcion") {
      nav(-1);
    }
  };

  //Modal Styles
  const style = {
    position: "inherit",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 375,
    bgcolor: theme.palette.background.alt,
    border: "2px solid #000",
    borderRadius: 4,
    boxShadow: 1,
    p: 4,
  };

  //Inputs States
  const [estadoSalud, setEstadoSalud] = useState(proyect.estado);
  const [municipioSalud, setMunicipioSalud] = useState(proyect.municipio);
  const [parroquiaSalud, setParroquiaSalud] = useState(proyect.parroquia);
  const [comunidadSalud, setComunidadSalud] = useState(proyect.comunidad);
  const [estSalud, setEstSalud] = useState(proyect.centro);
  const [valueCedula, setValueCedula] = useState(proyect.cedula);
  const [tlf, setValueTlf] = useState({ textmask: proyect.telefono });
  const handleTlf = (event) => {
    setValueTlf({
      ...tlf,
      [event.target.name]: event.target.value,
    });
  };
  const [peso, setPeso] = useState(proyect.peso);
  const [valueRep, setValueRep] = useState(proyect.nombre_rep);
  const [valueApellidoRep, setValueApellidoRep] = useState(
    proyect.apellido_rep
  );
  const [codigoBeneficiario, setCodigoBeneficiario] = useState(proyect.codigo);
  const [valueNombre, setValueNombre] = useState(proyect.nombre);
  const [valueApellido, setValueApellido] = useState(proyect.apellido);
  const [valueComunidad, setValueComunidad] = useState(proyect.comunidad);
  const [edadSalud, setEdadSalud] = useState(proyect.edad);
  const [rangoEdadSalud, setRangoEdadSalud] = useState(proyect.rango_edad);
  const [valueTipoDisc, setValueTipoDisc] = useState("");
  const [valueDiagnostico1, setValueDiagnostico1] = useState("");
  const [valueDiagnostico2, setValueDiagnostico2] = useState("");
  const [valueDiagnostico3, setValueDiagnostico3] = useState("");
  const [valueMedico, setValueMedico] = useState("");
  const [comentAdicionales, setValueCA] = useState(proyect.comentarios);

  const [codigoGrupoEtnico, setCodigoGrupoEtnico] = useState(
    proyect.grupo_etnico
  );
  const handleCodigoGrupoEtnico = (event) => {
    const inputValue = event.target.value;
    clearError("codigoGrupoEtnico");
    if (inputValue === "") {
      setCodigoGrupoEtnico("");
      return;
    }
    const numValue = parseInt(inputValue, 10);
    if (!isNaN(numValue) && numValue >= 1 && numValue <= 7) {
      setCodigoGrupoEtnico(numValue.toString());
    } else if (!isNaN(numValue) && (numValue < 1 || numValue > 7)) {
      setCodigoGrupoEtnico("");
    } else {
      setCodigoGrupoEtnico(inputValue);
    }
  };

  const [grupoEtnico, setGrupoEtnico] = React.useState("");
  useEffect(() => {
    const map = {
      1: "Mestizo",
      2: "Wayuu",
      3: "Añu",
      4: "Japreria",
      5: "Yanomami",
      6: "Bari",
      7: "Yukpa",
    };
    if (map[codigoGrupoEtnico]) {
      setGrupoEtnico(map[codigoGrupoEtnico]);
    } else if (codigoGrupoEtnico) {
      setGrupoEtnico("VERIFICAR CÓDIGO");
    } else {
      setGrupoEtnico("");
    }
  }, [codigoGrupoEtnico]);

  const [codigoDisc, setCodigoDisc] = useState(proyect.discapacidad);
  const handleCodigoDisc = (event) => {
    const inputValue = event.target.value;
    clearError("codigoDisc");
    if (inputValue === "") {
      setCodigoDisc("");
      return;
    }
    const numValue = parseInt(inputValue, 10);
    if (!isNaN(numValue) && numValue >= 1 && numValue <= 5) {
      setCodigoDisc(numValue.toString());
    } else if (!isNaN(numValue) && (numValue < 1 || numValue > 5)) {
      setCodigoDisc("");
    } else {
      setCodigoDisc(inputValue);
    }
  };

  const [valueDisc, setDisc] = React.useState("");
  useEffect(() => {
    const map = {
      1: "Física",
      2: "Intelectual",
      3: "Sensorial",
      4: "Múltiple",
      5: "Ninguna",
    };
    if (map[codigoDisc]) {
      setDisc(map[codigoDisc]);
    } else if (codigoDisc) {
      setDisc("VERIFICAR CÓDIGO");
    } else {
      setDisc("");
    }
  }, [codigoDisc]);

  const [codigoMovilidad, setCodigoMovilidad] = useState(proyect.movilidad);
  const handleCodigoMovilidad = (event) => {
    const inputValue = event.target.value;
    clearError("codigoMovilidad");
    if (inputValue === "") {
      setCodigoMovilidad("");
      return;
    }
    const numValue = parseInt(inputValue, 10);
    if (!isNaN(numValue) && numValue >= 1 && numValue <= 5) {
      setCodigoMovilidad(numValue.toString());
    } else if (!isNaN(numValue) && (numValue < 1 || numValue > 5)) {
      setCodigoMovilidad("");
    } else {
      setCodigoMovilidad(inputValue);
    }
  };

  const [condicionMovilidad, setCondicionMovilidad] = React.useState("");
  useEffect(() => {
    const map = {
      1: "Local",
      2: "Desplazado Interno",
      3: "Refugiado",
      4: "Retornado",
      5: "Pendular",
    };
    if (map[codigoMovilidad]) {
      setCondicionMovilidad(map[codigoMovilidad]);
    } else if (codigoMovilidad) {
      setCondicionMovilidad("VERIFICAR CÓDIGO");
    } else {
      setCondicionMovilidad("");
    }
  }, [codigoMovilidad]);

  const [codigoFactoresRiesgo, setCodigoFactoresRiesgo] = useState(
    proyect.factores_riesgo1
  );
  const handleCodigoFactoresRiesgo = (event) => {
    const inputValue = event.target.value;
    clearError("codigoFactoresRiesgo");
    if (inputValue === "") {
      setCodigoFactoresRiesgo("");
      return;
    }
    const numValue = parseInt(inputValue, 10);
    if (!isNaN(numValue) && numValue >= 1 && numValue <= 12) {
      setCodigoFactoresRiesgo(numValue.toString());
    } else if (!isNaN(numValue) && (numValue < 1 || numValue > 12)) {
      setCodigoFactoresRiesgo("");
    } else {
      setCodigoFactoresRiesgo(inputValue);
    }
  };

  const [factoresRiesgo, setFactoresRiesgo] = React.useState("");
  useEffect(() => {
    const map = {
      1: "Abuso emocional o psicológico",
      2: "Abuso físico",
      3: "Abuso sexual",
      4: "Embarazo adolescente",
      5: "Explotación sexual",
      6: "Falta de documentos de identidad",
      7: "Matrimonio infantil",
      8: "Negligencia",
      9: "No acompañado (<18 años)",
      10: "Trabajo infantil",
      11: "Trastorno mental",
      12: "No aplica",
    };
    if (map[codigoFactoresRiesgo]) {
      setFactoresRiesgo(map[codigoFactoresRiesgo]);
    } else if (codigoFactoresRiesgo) {
      setFactoresRiesgo("VERIFICAR CÓDIGO");
    } else {
      setFactoresRiesgo("");
    }
  }, [codigoFactoresRiesgo]);

  const [codigoFactoresRiesgo2, setCodigoFactoresRiesgo2] = useState(
    proyect.factores_riesgo2
  );
  const handleCodigoFactoresRiesgo2 = (event) => {
    const inputValue = event.target.value;
    clearError("codigoFactoresRiesgo2");
    if (inputValue === "") {
      setCodigoFactoresRiesgo2("");
      return;
    }
    const numValue = parseInt(inputValue, 10);
    if (!isNaN(numValue) && numValue >= 1 && numValue <= 12) {
      setCodigoFactoresRiesgo2(numValue.toString());
    } else if (!isNaN(numValue) && (numValue < 1 || numValue > 12)) {
      setCodigoFactoresRiesgo2("");
    } else {
      setCodigoFactoresRiesgo2(inputValue);
    }
  };

  const [factoresRiesgo2, setFactoresRiesgo2] = React.useState("");
  useEffect(() => {
    const map = {
      1: "Abuso emocional o psicológico",
      2: "Abuso físico",
      3: "Abuso sexual",
      4: "Embarazo adolescente",
      5: "Explotación sexual",
      6: "Falta de documentos de identidad",
      7: "Matrimonio infantil",
      8: "Negligencia",
      9: "No acompañado (<18 años)",
      10: "Trabajo infantil",
      11: "Trastorno mental",
      12: "No aplica",
    };
    if (map[codigoFactoresRiesgo2]) {
      setFactoresRiesgo2(map[codigoFactoresRiesgo2]);
    } else if (codigoFactoresRiesgo2) {
      setFactoresRiesgo2("VERIFICAR CÓDIGO");
    } else {
      setFactoresRiesgo2("");
    }
  }, [codigoFactoresRiesgo2]);

  const [codigoFactoresRiesgo3, setCodigoFactoresRiesgo3] = useState(
    proyect.factores_riesgo3
  );
  const handleCodigoFactoresRiesgo3 = (event) => {
    const inputValue = event.target.value;
    clearError("codigoFactoresRiesgo3");
    if (inputValue === "") {
      setCodigoFactoresRiesgo3("");
      return;
    }
    const numValue = parseInt(inputValue, 10);
    if (!isNaN(numValue) && numValue >= 1 && numValue <= 12) {
      setCodigoFactoresRiesgo3(numValue.toString());
    } else if (!isNaN(numValue) && (numValue < 1 || numValue > 12)) {
      setCodigoFactoresRiesgo3("");
    } else {
      setCodigoFactoresRiesgo3(inputValue);
    }
  };

  const [factoresRiesgo3, setFactoresRiesgo3] = React.useState("");
  useEffect(() => {
    const map = {
      1: "Abuso emocional o psicológico",
      2: "Abuso físico",
      3: "Abuso sexual",
      4: "Embarazo adolescente",
      5: "Explotación sexual",
      6: "Falta de documentos de identidad",
      7: "Matrimonio infantil",
      8: "Negligencia",
      9: "No acompañado (<18 años)",
      10: "Trabajo infantil",
      11: "Trastorno mental",
      12: "No aplica",
    };
    if (map[codigoFactoresRiesgo3]) {
      setFactoresRiesgo3(map[codigoFactoresRiesgo3]);
    } else if (codigoFactoresRiesgo3) {
      setFactoresRiesgo3("VERIFICAR CÓDIGO");
    } else {
      setFactoresRiesgo3("");
    }
  }, [codigoFactoresRiesgo3]);

  const [codigoNivelEducativo, setCodigoNivelEducativo] = useState(
    proyect.nivel_educativo
  );
  const handleCodigoNivelEducativo = (event) => {
    const inputValue = event.target.value;
    clearError("codigoNivelEducativo");
    if (inputValue === "") {
      setCodigoNivelEducativo("");
      return;
    }
    const numValue = parseInt(inputValue, 10);
    if (!isNaN(numValue) && numValue >= 1 && numValue <= 6) {
      setCodigoNivelEducativo(numValue.toString());
    } else if (!isNaN(numValue) && (numValue < 1 || numValue > 6)) {
      setCodigoNivelEducativo("");
    } else {
      setCodigoNivelEducativo(inputValue);
    }
  };

  const [nivelEducativo, setNivelEducativo] = React.useState("");
  useEffect(() => {
    const map = {
      1: "Prescolar",
      2: "Primaria",
      3: "Secundaria",
      4: "Universitario",
      5: "Sin estudios",
      6: "Analfabeta",
    };
    if (map[codigoNivelEducativo]) {
      setNivelEducativo(map[codigoNivelEducativo]);
    } else if (codigoNivelEducativo) {
      setNivelEducativo("VERIFICAR CÓDIGO");
    } else {
      setNivelEducativo("");
    }
  }, [codigoNivelEducativo]);

  const [medicamentos, setMedicamentos] = useState([]);
  const [tratamiento, setTratamiento] = useState([]);
  const [inputTratamiento, setInputTratamiento] = useState([]);
  const [codigoProyectoV2, setCodigoProyectoV2] = useState(
    proyect.codigo_proyecto ?? proyect.codigoProyecto ?? ""
  );

  const [medicoM5, setMedicoM5] = useState(proyect.medicoId);
  const [ejecutar, setEjecutar] = React.useState(true);
  const [usuarios, setUsuarios] = useState([]);

  // States for Autocomplete
  const [value, setValue] = React.useState(null);
  const [inputValue, setInputValue] = useState(proyect.medico || "");

  ///////////////////// Disable Button State ////////////////////////////
  const [disableBtnSalud, setDisableBtnSalud] = React.useState(false);

  //////////////////////////////////////////////////////////////////////
  const oracionFormato = (string) => {
    if (typeof string !== "string") return "";
    return string
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
  ////////////////////////////////////////////////////////////////////

  const getUsuarios = async () => {
    try {
      const { data } = await axios.get("/usuariostranscripcion");
      let datos = data;
      for (let i = 0; i < datos.length; i++) {
        datos[i].nombreCompleto = datos[i].nombres + " " + datos[i].apellidos;
      }
      setUsuarios(datos);
    } catch (error) {
      console.log("error fetching users", error);
    }
  };
  const getMedicamentos = async () => {
    if (!codigoProyectoV2) return;

    try {
      const { data } = await axios.get("/medicamentos/", {
        params: {
          codigoProyecto: Number(codigoProyectoV2),
          sector: 3,
        },
      });
      setMedicamentos(Array.isArray(data) ? data.map(normalizeMedicationV2) : []);
    } catch (error) {
      console.log(error, "error fetching meds");
    }
  };

  //Select States
  const [valueGenero, setValueGenero] = React.useState(proyect.genero);
  const handleChangeGenero = (event) => {
    clearError("valueGenero");
    setValueGenero(event.target.value);
  };

  const [valueTipoEnf, setValueTipoEnf] = React.useState("");
  const handleChangeValueTipoEnf = (event) => {
    setValueTipoEnf(event.target.value);
  };

  const [rangoEdadBenef, setRangoEdadBenef] = React.useState("");
  const handleChangeRangoEdad = (event) => {
    setRangoEdadBenef(event.target.value);
  };

  const handleChangeDisc = (event) => {
    clearError("codigoDisc");
    setDisc(event.target.value);
  };

  const [sexoBenef, setSexoBenef] = React.useState(proyect.sexo);
  const handleSexoBenef = (event) => {
    clearError("sexoBenef");
    setSexoBenef(event.target.value);
  };

  const [lgbtqi, setLgbtqi] = React.useState(proyect.lgbtqi);
  const handleLgbtqi = (event) => {
    clearError("lgbtqi");
    setLgbtqi(event.target.value);
  };

  const handleGrupoEtnico = (event) => {
    setGrupoEtnico(event.target.value);
  };

  const handleCondicionMovilidad = (event) => {
    setCondicionMovilidad(event.target.value);
  };

  const handleFactoresRiesgo = (event) => {
    setFactoresRiesgo(event.target.value);
  };

  const handleFactoresRiesgo2 = (event) => {
    setFactoresRiesgo2(event.target.value);
  };

  const handleFactoresRiesgo3 = (event) => {
    setFactoresRiesgo3(event.target.value);
  };

  const handleNivelEducativo = (event) => {
    setNivelEducativo(event.target.value);
  };

  const [cabezaFamilia, setCabezaFamilia] = React.useState(
    proyect.cabeza_familia
  );
  const handleCabezaFamilia = (event) => {
    clearError("cabezaFamilia");
    setCabezaFamilia(event.target.value);
  };

  const [ingresosPropios, setIngresosPropios] = React.useState(
    proyect.ingresos
  );
  const handleIngresosPropios = (event) => {
    clearError("ingresosPropios");
    setIngresosPropios(event.target.value);
  };

  ///////////////// CALCULO DE EDAD ///////////////////
  useEffect(() => {
    if (fechaNacSalud) {
      const currentDate = new Date(fechaActSalud);
      const birthDate = new Date(fechaNacSalud);

      if (!isNaN(birthDate.getTime())) {
        const diffTime = currentDate - birthDate;
        const totalDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
        const years = Math.floor(totalDays / 365.25);

        setEdadSalud(
          `${years} año(s) y ${Math.floor(
            (totalDays % 365.25) / 30.4375
          )} mes(es)`
        );

        // Condición principal: Verificamos si la actividad es del tipo 3
        if (tipoActividad === "Telemedicina") {
          // Nueva lógica de rangos para Telemedicina + Jornada Médica
          if (years >= 0 && years <= 11) {
            setRangoEdadSalud("0-11 años");
          } else if (years >= 12 && years <= 17) {
            setRangoEdadSalud("12-17 años");
          } else if (years >= 18 && years <= 35) {
            setRangoEdadSalud("18-35 años");
          } else if (years >= 36 && years <= 54) {
            setRangoEdadSalud("36-54 años");
          } else {
            // years >= 55
            setRangoEdadSalud("Mayor de 55 años");
          }
          setValueRep("N/A");
          setValueApellidoRep("N/A");
          clearError("valueRep");
          clearError("valueApellidoRep");
        } else {
          // Lógica original para cualquier otro tipo de actividad
          if (years <= 4) {
            setRangoEdadSalud("0-4 años");
          } else if (years <= 17) {
            setRangoEdadSalud("5-17 años");
          } else {
            if (years <= 49) {
              setRangoEdadSalud("18-49 años");
            } else {
              setRangoEdadSalud("50 años o más");
            }
            setValueRep("N/A");
            setValueApellidoRep("N/A");
            clearError("valueRep");
            clearError("valueApellidoRep");
          }
        }
      } else {
        setEdadSalud("");
        setRangoEdadSalud("");
      }
    } else {
      setEdadSalud("");
      setRangoEdadSalud("");
      setValueRep("");
      setValueApellidoRep("");
    }
  }, [fechaNacSalud, fechaActSalud, tipoActividad]);
  ///////////////////////////////////////////////

  //Alerts Handlers
  const [openAlert, setOpenAlert] = React.useState(false);
  const [openNotiError, setOpenNotiError] = React.useState(false);
  const [apiErrorMessage, setApiErrorMessage] = React.useState("");
  const [recordLoading, setRecordLoading] = React.useState(true);
  const [recordLoadError, setRecordLoadError] = React.useState("");
  const [recordVersion, setRecordVersion] = React.useState(null);
  const [recordConvocatoriaId, setRecordConvocatoriaId] = React.useState(
    proyect.id_convocatoria ?? proyect.idConvocatoria ?? proyect.convocatoriaId ?? null
  );
  const [recordEditable, setRecordEditable] = React.useState(true);
  const [recordSource, setRecordSource] = React.useState("");

  useEffect(() => {
    const medicoSeleccionado = usuarios.find(
      (usuario) => String(usuario.id) === String(medicoM5)
    );
    setValue(medicoSeleccionado || null);
  }, [medicoM5, usuarios]);

  useEffect(() => {
    getMedicamentos();
  }, [codigoProyectoV2]);

  useEffect(() => {
    if (!medicamentos.length) return;

    setTratamiento((current) =>
      current.map((selected) => {
        const selectedId = selected.medicamentoId;
        return (
          medicamentos.find(
            (medicamento) => String(medicamento.medicamentoId) === String(selectedId)
          ) || selected
        );
      })
    );
  }, [medicamentos]);

  useEffect(() => {
    let active = true;

    const loadRecord = async () => {
      if (!recordId) {
        setRecordLoadError("No se indicó el registro de salud que desea editar.");
        setRecordLoading(false);
        return;
      }

      try {
        setRecordLoading(true);
        setRecordLoadError("");
        const response = await axios.get(`${SALUD_CLINICA_V2_ENDPOINT}/${recordId}`);
        if (!active) return;

        const record = normalizeSaludV2Response(response.data);
        const motivos = [1, 2, 3, 4, 5]
          .map((index) => record[`motivoConsulta${index}`] ?? record[`motivo_consulta${index}`])
          .filter((motivo) => motivo !== null && motivo !== undefined && motivo !== "")
          .map((motivoConsulta) => ({ motivoConsulta }));
        const source = String(record.source || "").toUpperCase();
        const editable = !(source === "LEGACY" && record.editableInV2 === false);

        setRecordSource(source);
        setRecordEditable(editable);
        if (!editable) return;
        if (record.version === null || record.version === undefined) {
          setRecordLoadError("La respuesta del registro no incluye la versión requerida para editar.");
          return;
        }

        setEstadoSalud(record.estado || "");
        setMunicipioSalud(record.municipio || "");
        setParroquiaSalud(record.parroquia || "");
        setComunidadSalud(record.comunidad || "");
        setEstSalud(record.centro || "");
        setValueCedula(record.cedula || "");
        setValueTlf({ textmask: record.telefono || "" });
        setPeso(record.peso || "");
        setValueRep(record.nombre_rep ?? record.nombreRep ?? "");
        setValueApellidoRep(record.apellido_rep ?? record.apellidoRep ?? "");
        setCodigoBeneficiario(record.codigo || "");
        setValueNombre(record.nombre || "");
        setValueApellido(record.apellido || "");
        setEdadSalud(record.edad || "");
        setRangoEdadSalud(record.rango_edad ?? record.rangoEdad ?? "");
        setValueCA(record.comentarios || "");
        setCodigoGrupoEtnico(record.grupo_etnico ?? record.grupoEtnico ?? "");
        setCodigoDisc(record.discapacidad ?? "");
        setCodigoMovilidad(record.movilidad ?? "");
        setCodigoFactoresRiesgo(record.factores_riesgo1 ?? record.factoresRiesgo1 ?? "");
        setCodigoFactoresRiesgo2(record.factores_riesgo2 ?? record.factoresRiesgo2 ?? "");
        setCodigoFactoresRiesgo3(record.factores_riesgo3 ?? record.factoresRiesgo3 ?? "");
        setCodigoNivelEducativo(record.nivel_educativo ?? record.nivelEducativo ?? "");
        setFechaNacSalud(record.fecha_nacimiento ?? record.fechaNacimiento ?? null);
        setFechaActSalud(record.fecha_evaluacion ?? record.fechaEvaluacion ?? null);
        setValueGenero(record.genero || "");
        setSexoBenef(record.sexo || "");
        setLgbtqi(record.lgbtqi || "");
        setCabezaFamilia(record.cabeza_familia ?? record.cabezaFamilia ?? "");
        setIngresosPropios(record.ingresos || "");
        setData(motivos.length ? motivos : [{ motivoConsulta: "" }]);
        setDiagnosticos(
          Array.isArray(record.diagnosticos) && record.diagnosticos.length
            ? record.diagnosticos
                .sort((a, b) => Number(a.orden || 0) - Number(b.orden || 0))
                .map(normalizeDiagnosisV2)
            : [createEmptyDiagnosisV2()]
        );
        setTratamiento(
          Array.isArray(record.tratamientos)
            ? record.tratamientos.map(normalizeMedicationV2)
            : []
        );
        setCodigoProyectoV2(
          record.codigo_proyecto ?? record.codigoProyecto ?? record.proyecto?.codigo ?? ""
        );
        setMedicoM5(record.medicoId ?? record.medico_id ?? record.medico?.id ?? "");
        setInputValue(
          record.medicoNombre ?? record.medico_nombre ?? record.medico?.nombreCompleto ?? ""
        );
        setRecordVersion(record.version ?? null);
        setRecordConvocatoriaId(record.convocatoriaId ?? null);
      } catch (error) {
        if (active) setRecordLoadError(extractApiErrorV2(error).message);
      } finally {
        if (active) setRecordLoading(false);
      }
    };

    loadRecord();
    return () => {
      active = false;
    };
  }, [recordId]);

  const getCurrentSaludValues = () => {
    const motivosConsulta = data.map((item) => item.motivoConsulta);
    const cedula = valueCedula && valueCedula.trim() === "" ? "N/P" : valueCedula;
    const telefono =
      !tlf.textmask ||
      tlf.textmask.trim() === "" ||
      tlf.textmask.trim() === "+" ||
      tlf.textmask === "+00(__) 000-0000"
        ? "N/P"
        : tlf.textmask;

    return {
      estado: estadoSalud,
      municipio: municipioSalud,
      parroquia: parroquiaSalud,
      centro: estSalud,
      comunidad: comunidadSalud,
      grupo_etnico: codigoGrupoEtnico,
      cedula,
      nombre_rep: valueRep,
      apellido_rep: valueApellidoRep,
      telefono,
      codigo: codigoBeneficiario,
      nombre: valueNombre,
      apellido: valueApellido,
      sexo: sexoBenef,
      genero: valueGenero,
      lgbtqi,
      nivel_educativo: codigoNivelEducativo,
      rango_edad: rangoEdadSalud,
      ingresos: ingresosPropios,
      movilidad: codigoMovilidad,
      factores_riesgo1: codigoFactoresRiesgo,
      factores_riesgo2: codigoFactoresRiesgo2,
      factores_riesgo3: codigoFactoresRiesgo3,
      cabeza_familia: cabezaFamilia,
      motivoConsulta1: motivosConsulta[0] || null,
      motivoConsulta2: motivosConsulta[1] || null,
      motivoConsulta3: motivosConsulta[2] || null,
      motivoConsulta4: motivosConsulta[3] || null,
      motivoConsulta5: motivosConsulta[4] || null,
      fecha_nacimiento: fechaNacSalud,
      fecha_evaluacion: fechaActSalud,
      edad: edadSalud,
      discapacidad: codigoDisc,
      peso,
      comentarios: comentAdicionales,
    };
  };

  const validateForm = () => {
    const newErrors = {};
    const years = fechaNacSalud
      ? Math.floor(
          (new Date(fechaActSalud) - new Date(fechaNacSalud)) /
            (1000 * 60 * 60 * 24 * 365.25)
        )
      : -1;

    // Datos del Beneficiario
    if (!codigoBeneficiario.trim())
      newErrors.codigoBeneficiario = "Este campo es requerido";
    if (!valueNombre.trim()) newErrors.valueNombre = "Este campo es requerido";
    if (!valueApellido.trim())
      newErrors.valueApellido = "Este campo es requerido";
    if (!sexoBenef) newErrors.sexoBenef = "Este campo es requerido";
    if (!valueGenero) newErrors.valueGenero = "Este campo es requerido";
    if (!fechaNacSalud) newErrors.fechaNacSalud = "Este campo es requerido";

    // Datos del Representante
    if (!valueRep.trim()) newErrors.valueRep = "Requerido para menores de edad";
    if (!valueApellidoRep.trim())
      newErrors.valueApellidoRep = "Requerido para menores de edad";

    // Datos Demográficos
    if (!lgbtqi) newErrors.lgbtqi = "Este campo es requerido";
    if (!comunidadSalud.trim())
      newErrors.comunidadSalud = "Este campo es requerido";
    if (!codigoGrupoEtnico || grupoEtnico === "VERIFICAR CÓDIGO")
      newErrors.codigoGrupoEtnico = "Código inválido o requerido";
    if (!codigoDisc || valueDisc === "VERIFICAR CÓDIGO")
      newErrors.codigoDisc = "Código inválido o requerido";
    if (!codigoMovilidad || condicionMovilidad === "VERIFICAR CÓDIGO")
      newErrors.codigoMovilidad = "Código inválido o requerido";
    if (!codigoFactoresRiesgo || factoresRiesgo === "VERIFICAR CÓDIGO")
      newErrors.codigoFactoresRiesgo = "Código inválido o requerido";
    if (!codigoFactoresRiesgo2 || factoresRiesgo2 === "VERIFICAR CÓDIGO")
      newErrors.codigoFactoresRiesgo2 = "Código inválido o requerido";
    if (!codigoFactoresRiesgo3 || factoresRiesgo3 === "VERIFICAR CÓDIGO")
      newErrors.codigoFactoresRiesgo3 = "Código inválido o requerido";
    if (!codigoNivelEducativo || nivelEducativo === "VERIFICAR CÓDIGO")
      newErrors.codigoNivelEducativo = "Código inválido o requerido";
    if (!cabezaFamilia) newErrors.cabezaFamilia = "Este campo es requerido";
    if (!ingresosPropios) newErrors.ingresosPropios = "Este campo es requerido";

    // Datos de Consulta y Manejo
    /*if (years >= 0 && years < 18 && !peso.trim())
      newErrors.peso = "Requerido para menores de edad";*/
    if (data.some((item) => !item.motivoConsulta.trim()))
      newErrors.motivoConsulta = "Debe rellenar todos los motivos.";
    const diagnosisError = validateDiagnosesV2(diagnosticos);
    if (diagnosisError) newErrors.diagnostico = diagnosisError;
    if (tratamiento.length === 0)
      newErrors.tratamiento = "Debe seleccionar al menos un tratamiento.";

    // Adicionales
    if (!inputValue.trim() || !medicoM5)
      newErrors.medico = "Debe seleccionar un médico responsable.";
    if (!recordConvocatoriaId)
      newErrors.convocatoriaId = "El registro no incluye la convocatoria requerida para editar.";

    const limitErrors = validateSaludV2FieldLimits(
      buildSaludV2Payload(getCurrentSaludValues())
    );
    if (limitErrors.length) {
      newErrors.saludV2Limits = limitErrors.map(({ message }) => message).join(" ");
      setApiErrorMessage(newErrors.saludV2Limits);
    } else if (!newErrors.convocatoriaId) {
      setApiErrorMessage("");
    }
    if (newErrors.convocatoriaId) setApiErrorMessage(newErrors.convocatoriaId);

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) {
      setOpenNotiError(true);
      setTimeout(() => setOpenNotiError(false), 3000);
      return;
    }

    setDisableBtnSalud(true);

    try {
      await axios.put(`${SALUD_CLINICA_V2_ENDPOINT}/${recordId}`, buildSaludV2Request({
        convocatoriaId: recordConvocatoriaId,
        expectedVersion: recordVersion,
        medicoId: medicoM5,
        salud: getCurrentSaludValues(),
        diagnosticos,
        tratamientos: tratamiento,
      }))
        .then(function (response) {
          setOpenAlert(true);
          setTimeout(() => {
            setOpenAlert(false);
            nav(-1);
          }, 2000);
        })
        .catch(function (error) {
          setApiErrorMessage(extractApiErrorV2(error).message);
          setOpenNotiError(true);
          setTimeout(() => setOpenNotiError(false), 3000);
        })
        .finally(() => {
          setDisableBtnSalud(false);
        });
    } catch (error) {
      setApiErrorMessage(extractApiErrorV2(error).message);
      setDisableBtnSalud(false);
    }
  };

  useEffect(() => {
    if (ejecutar) {
      getUsuarios();
      setEjecutar(false);
    }
  }, [ejecutar]);

  if (!canEditSaludV2(items)) {
    return (
      <Box m="1.5rem 2.5rem">
        <Restricted />
      </Box>
    );
  }

  if (recordLoading) {
    return (
      <Box minHeight={280} display="flex" alignItems="center" justifyContent="center">
        <CircularProgress />
      </Box>
    );
  }

  if (recordLoadError) {
    return (
      <Box m="1.5rem 2.5rem">
        <Alert severity="error">{recordLoadError}</Alert>
      </Box>
    );
  }

  if (!recordEditable) {
    return (
      <Box m="1.5rem 2.5rem">
        <Alert severity="warning">
          El registro de origen {recordSource || "LEGACY"} no está habilitado para edición clínica V2.
        </Alert>
      </Box>
    );
  }

  return (
    <Box m="1.5rem 2.5rem">
      {canEditSaludV2(items) ? (
        <>
          <Collapse in={openAlert}>
            <Alert
              variant="filled"
              severity="success"
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpenAlert(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{
                position: "fixed",
                right: 12,
                zIndex: 999,
                borderRadius: 2,
                boxShadow: 4,
              }}
            >
              ¡Datos guardados exitosamente!
            </Alert>
          </Collapse>
          <Collapse in={openNotiError}>
            <Alert
              variant="filled"
              severity="error"
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setOpenNotiError(false);
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{
                position: "fixed",
                right: 12,
                zIndex: 999,
                borderRadius: 2,
                boxShadow: 4,
              }}
            >
              {apiErrorMessage || "¡Error al guardar! Verifique los campos requeridos."}
            </Alert>
          </Collapse>
          <Box
            gridColumn="span 2"
            gridRow="span 1"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            p="1.25rem 1rem"
            flex="1 1 100%"
            borderRadius="0.55rem"
          >
            <CssBaseline />
            <Box
              role="presentation"
              onClick={handleClickBreadCrumbs}
              sx={{ mb: 3 }}
            >
              <Breadcrumbs aria-label="breadcrumb">
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  href="/inicio"
                  onClick={(event) => handleLinkHome(event, "home")}
                >
                  <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                  Inicio
                </Link>
                <Link
                  underline="hover"
                  sx={{ display: "flex", alignItems: "center" }}
                  color="inherit"
                  href="/listaTranscripcion"
                  onClick={(event) =>
                    handleLinkTranscripcion(event, "transcripcion")
                  }
                >
                  <DriveFileRenameOutlineIcon
                    sx={{ mr: 0.5 }}
                    fontSize="inherit"
                  />
                  Transcripción
                </Link>
                <Typography
                  sx={{ display: "flex", alignItems: "center" }}
                  color="text.primary"
                >
                  <NoteAddOutlinedIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                  {tipoActividad === "Telemedicina"
                    ? "Nuevo Beneficiario (Salud/Telemedicina)"
                    : "Nuevo Beneficiario (Salud)"}
                </Typography>
              </Breadcrumbs>
              <Typography
                variant="h3"
                component="div"
                sx={{ mt: 3, mb: 1, fontWeight: "bold" }}
              >
                {tipoActividad === "Telemedicina"
                  ? "Nuevo Beneficiario (Salud/Telemedicina)"
                  : "Nuevo Beneficiario (Salud)"}
              </Typography>
            </Box>
            <Container>
              <Card
                sx={{
                  borderRadius: 8,
                  boxShadow: 5,
                  bgcolor: theme.palette.background.alt,
                }}
              >
                <CardContent>
                  <Box
                    component="form"
                    noValidate
                    onSubmit={handleSubmit}
                    sx={{ mt: 3 }}
                  >
                    <Box>
                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip label="INFO. GENERAL" />
                      </Divider>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            required
                            fullWidth
                            label="Estado"
                            value={estadoSalud}
                            disabled
                            onChange={(event) =>
                              setEstadoSalud(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            required
                            fullWidth
                            label="Municipio"
                            value={municipioSalud}
                            disabled
                            onChange={(event) =>
                              setMunicipioSalud(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            required
                            fullWidth
                            label="Parroquia"
                            value={parroquiaSalud}
                            disabled
                            onChange={(event) =>
                              setParroquiaSalud(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            required
                            fullWidth
                            label="Establecimiento de Salud"
                            value={estSalud}
                            disabled
                            onChange={(event) =>
                              setEstSalud(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            adapterLocale="es"
                          >
                            <DesktopDatePicker
                              label="Fecha de Atención"
                              name="fechaActividad"
                              inputFormat="DD/MM/YYYY"
                              value={fechaActSalud}
                              onChange={setFechaActSalud}
                              disabled
                              renderInput={(params) => {
                                return <TextField fullWidth {...params} />;
                              }}
                              clearable
                            />
                          </LocalizationProvider>
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip label="DATOS DEL BENEFICIARIO" />
                      </Divider>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            label="Codigo"
                            fullWidth
                            required
                            value={codigoBeneficiario}
                            onChange={(event) => {
                              setCodigoBeneficiario(
                                oracionFormato(event.target.value)
                              );
                              clearError("codigoBeneficiario");
                            }}
                            error={!!errors.codigoBeneficiario}
                            helperText={errors.codigoBeneficiario}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            label="Primer Nombre"
                            fullWidth
                            required
                            value={valueNombre}
                            onChange={(event) => {
                              setValueNombre(
                                oracionFormato(event.target.value)
                              );
                              clearError("valueNombre");
                            }}
                            error={!!errors.valueNombre}
                            helperText={errors.valueNombre}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            label="Primer Apellido"
                            fullWidth
                            required
                            value={valueApellido}
                            onChange={(event) => {
                              setValueApellido(
                                oracionFormato(event.target.value)
                              );
                              clearError("valueApellido");
                            }}
                            error={!!errors.valueApellido}
                            helperText={errors.valueApellido}
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth error={!!errors.sexoBenef}>
                            <InputLabel id="sexo">Sexo</InputLabel>
                            <Select
                              value={sexoBenef}
                              label="Sexo"
                              onChange={handleSexoBenef}
                            >
                              <MenuItem value={"Mujer"}>Mujer</MenuItem>
                              <MenuItem value={"Hombre"}>Hombre</MenuItem>
                            </Select>
                            {errors.sexoBenef && (
                              <FormHelperText>
                                {errors.sexoBenef}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth error={!!errors.valueGenero}>
                            <InputLabel id="genero">Género</InputLabel>
                            <Select
                              value={valueGenero}
                              label="Género"
                              onChange={handleChangeGenero}
                            >
                              <MenuItem value={"Femenino"}>Femenino</MenuItem>
                              <MenuItem value={"Masculino"}>Masculino</MenuItem>
                              <MenuItem value={"Otro"}>Otro</MenuItem>
                            </Select>
                            {errors.valueGenero && (
                              <FormHelperText>
                                {errors.valueGenero}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            name="cedula"
                            fullWidth
                            id="cedula"
                            label="Cédula de Identidad"
                            value={valueCedula}
                            onChange={(event) =>
                              setValueCedula(
                                event.target.value.replace(/[^\d]/g, "")
                              )
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth>
                            <InputLabel htmlFor="telefono" variant="outlined">
                              Teléfono
                            </InputLabel>
                            <OutlinedInput
                              value={tlf.textmask}
                              onChange={handleTlf}
                              name="textmask"
                              id="telefono"
                              inputComponent={TextMaskCustom}
                              label="Teléfono"
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <LocalizationProvider
                            dateAdapter={AdapterDayjs}
                            adapterLocale="es"
                          >
                            <DesktopDatePicker
                              label="Fecha de Nacimiento"
                              name="fechaNacimiento"
                              inputFormat="DD/MM/YYYY"
                              value={fechaNacSalud}
                              onChange={(newValue) => {
                                setFechaNacSalud(newValue);
                                clearError("fechaNacSalud");
                              }}
                              renderInput={(params) => (
                                <TextField
                                  fullWidth
                                  {...params}
                                  error={!!errors.fechaNacSalud}
                                  helperText={errors.fechaNacSalud}
                                />
                              )}
                              clearable
                            />
                          </LocalizationProvider>
                        </Grid>
                        <Grid item xs={12} sm={tipoActividad === "Telemedicina" ? 2 : 4}>
                          <TextField
                            label="Edad"
                            fullWidth
                            required
                            disabled
                            value={edadSalud}
                            onChange={(event) =>
                              setEdadSalud(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={2} hidden={tipoActividad !== "Telemedicina"}>
                          <TextField
                            label="Grupo Etario"
                            fullWidth
                            required
                            disabled
                            value={rangoEdadSalud}
                            onChange={(event) =>
                              setRangoEdadSalud(event.target.value)
                            }
                          />
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip label="DATOS DEL REPRESENTANTE" />
                      </Divider>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            name="representante"
                            fullWidth
                            id="representante"
                            label="Primer Nombre"
                            disabled={
                              rangoEdadSalud === "18-49 años" ||
                              rangoEdadSalud === "50 años o más" ||
                              rangoEdadSalud === "18-35 años" ||
                              rangoEdadSalud === "36-54 años" ||
                              rangoEdadSalud === "Mayor de 55 años" ||
                              rangoEdadSalud === ""
                            }
                            value={valueRep}
                            onChange={(event) => {
                              setValueRep(oracionFormato(event.target.value));
                              clearError("valueRep");
                            }}
                            error={!!errors.valueRep}
                            helperText={errors.valueRep}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            fullWidth
                            label="Primer Apellido"
                            value={valueApellidoRep}
                            disabled={
                              rangoEdadSalud === "18-49 años" ||
                              rangoEdadSalud === "50 años o más" ||
                              rangoEdadSalud === "18-35 años" ||
                              rangoEdadSalud === "36-54 años" ||
                              rangoEdadSalud === "Mayor de 55 años" ||
                              rangoEdadSalud === ""
                            }
                            onChange={(event) => {
                              setValueApellidoRep(
                                oracionFormato(event.target.value)
                              );
                              clearError("valueApellidoRep");
                            }}
                            error={!!errors.valueApellidoRep}
                            helperText={errors.valueApellidoRep}
                          />
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip
                          label="DATOS DEMOGRÁFICOS DEL BENEFICIARIO"
                          sx={{
                            "&.MuiChip-root": {
                              fontSize: isSmallScreen ? "9px" : "auto",
                            },
                          }}
                        />
                      </Divider>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth error={!!errors.lgbtqi}>
                            <InputLabel id="lgbtqi">LGBTQI+</InputLabel>
                            <Select
                              value={lgbtqi}
                              label="LGBTQI+"
                              onChange={handleLgbtqi}
                            >
                              <MenuItem value={"Si"}>Si</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                            </Select>
                            {errors.lgbtqi && (
                              <FormHelperText>{errors.lgbtqi}</FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <TextField
                            required
                            fullWidth
                            label="Comunidad"
                            value={comunidadSalud}
                            onChange={(event) => {
                              setComunidadSalud(
                                oracionFormato(event.target.value)
                              );
                              clearError("comunidadSalud");
                            }}
                            error={!!errors.comunidadSalud}
                            helperText={errors.comunidadSalud}
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            required
                            fullWidth
                            error={!!errors.codigoGrupoEtnico}
                            label="Código"
                            type="number"
                            value={codigoGrupoEtnico}
                            onChange={handleCodigoGrupoEtnico}
                            helperText={errors.codigoGrupoEtnico}
                            inputProps={{ min: 1, max: 7, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={grupoEtnico === "VERIFICAR CÓDIGO"}
                            label="Grupo Etnico"
                            value={grupoEtnico}
                            disabled
                            onChange={(event) =>
                              setGrupoEtnico(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            required
                            fullWidth
                            type="number"
                            error={!!errors.codigoDisc}
                            label="Código"
                            value={codigoDisc}
                            onChange={handleCodigoDisc}
                            helperText={errors.codigoDisc}
                            inputProps={{ min: 1, max: 5, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={valueDisc === "VERIFICAR CÓDIGO"}
                            label="Discapacidad"
                            value={valueDisc}
                            disabled
                            onChange={(event) => setDisc(event.target.value)}
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            required
                            fullWidth
                            type="number"
                            error={!!errors.codigoMovilidad}
                            label="Código"
                            value={codigoMovilidad}
                            onChange={handleCodigoMovilidad}
                            helperText={errors.codigoMovilidad}
                            inputProps={{ min: 1, max: 5, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={condicionMovilidad === "VERIFICAR CÓDIGO"}
                            label="Condición de Movilidad"
                            value={condicionMovilidad}
                            disabled
                            onChange={(event) =>
                              setCondicionMovilidad(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            required
                            fullWidth
                            type="number"
                            error={!!errors.codigoFactoresRiesgo}
                            label="Código"
                            value={codigoFactoresRiesgo}
                            onChange={handleCodigoFactoresRiesgo}
                            helperText={errors.codigoFactoresRiesgo}
                            inputProps={{ min: 1, max: 12, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={factoresRiesgo === "VERIFICAR CÓDIGO"}
                            label="Factor de Riesgo 1"
                            value={factoresRiesgo}
                            disabled
                            onChange={(event) =>
                              setFactoresRiesgo(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            required
                            fullWidth
                            type="number"
                            error={!!errors.codigoFactoresRiesgo2}
                            label="Código"
                            value={codigoFactoresRiesgo2}
                            onChange={handleCodigoFactoresRiesgo2}
                            helperText={errors.codigoFactoresRiesgo2}
                            inputProps={{ min: 1, max: 12, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={factoresRiesgo2 === "VERIFICAR CÓDIGO"}
                            label="Factor de Riesgo 2"
                            value={factoresRiesgo2}
                            disabled
                            onChange={(event) =>
                              setFactoresRiesgo2(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            required
                            fullWidth
                            type="number"
                            error={!!errors.codigoFactoresRiesgo3}
                            label="Código"
                            value={codigoFactoresRiesgo3}
                            onChange={handleCodigoFactoresRiesgo3}
                            helperText={errors.codigoFactoresRiesgo3}
                            inputProps={{ min: 1, max: 12, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={factoresRiesgo3 === "VERIFICAR CÓDIGO"}
                            label="Factor de Riesgo 3"
                            value={factoresRiesgo3}
                            disabled
                            onChange={(event) =>
                              setFactoresRiesgo3(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={3} sm={1}>
                          <TextField
                            required
                            fullWidth
                            type="number"
                            error={!!errors.codigoNivelEducativo}
                            label="Código"
                            value={codigoNivelEducativo}
                            onChange={handleCodigoNivelEducativo}
                            helperText={errors.codigoNivelEducativo}
                            inputProps={{ min: 1, max: 6, step: 1 }}
                          />
                        </Grid>
                        <Grid item xs={9} sm={3}>
                          <TextField
                            fullWidth
                            error={nivelEducativo === "VERIFICAR CÓDIGO"}
                            label="Nivel Educativo"
                            value={nivelEducativo}
                            disabled
                            onChange={(event) =>
                              setNivelEducativo(event.target.value)
                            }
                          />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl fullWidth error={!!errors.cabezaFamilia}>
                            <InputLabel id="cabezaFamilia">
                              Cabeza de Familia
                            </InputLabel>
                            <Select
                              value={cabezaFamilia}
                              label="Cabeza de Familia"
                              onChange={handleCabezaFamilia}
                            >
                              <MenuItem value={"Si"}>Si</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                            </Select>
                            {errors.cabezaFamilia && (
                              <FormHelperText>
                                {errors.cabezaFamilia}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <FormControl
                            fullWidth
                            error={!!errors.ingresosPropios}
                          >
                            <InputLabel id="ingresosPropios">
                              Ingresos Propios
                            </InputLabel>
                            <Select
                              value={ingresosPropios}
                              label="Ingresos Propios"
                              onChange={handleIngresosPropios}
                            >
                              <MenuItem value={"Si"}>Si</MenuItem>
                              <MenuItem value={"No"}>No</MenuItem>
                            </Select>
                            {errors.ingresosPropios && (
                              <FormHelperText>
                                {errors.ingresosPropios}
                              </FormHelperText>
                            )}
                          </FormControl>
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: 4, mb: 2 }}>
                        <Chip label="DATOS DE CONSULTA Y MANEJO" />
                      </Divider>
                      <Grid
                        container
                        spacing={1}
                        hidden={
                          rangoEdadSalud === "18-49 años" ||
                          rangoEdadSalud === "50 años o más" ||
                          rangoEdadSalud === "18-35 años" ||
                          rangoEdadSalud === "36-54 años" ||
                          rangoEdadSalud === "Mayor de 55 años" ||
                          rangoEdadSalud === ""
                        }
                      >
                        <Grid
                          item
                          xs={12}
                          sm={5}
                          ml={2}
                          mb={!isSmallScreen ? 1 : 0}
                        >
                          <TextField
                            type="number"
                            label="Peso (Kg)"
                            value={peso}
                            onChange={(event) => {
                              setPeso(event.target.value);
                              //clearError("peso");
                            }}
                            sx={{ width: isSmallScreen ? "100%" : "94%" }}
                            //error={!!errors.peso}
                            //helperText={errors.peso}
                          />
                        </Grid>
                      </Grid>
                      <div style={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: isSmallScreen ? "column" : "row",
                          }}
                        >
                          <Item sx={{ width: "100%" }}>
                            {data.map((val, i) => (
                              <div key={i}>
                                <Grid container spacing={2}>
                                  <Grid
                                    item
                                    xs={
                                      data[0].motivoConsulta === "" ||
                                      data.length === 1
                                        ? 12
                                        : 9
                                    }
                                    sm={10}
                                    mt={1}
                                  >
                                    <TextField
                                      fullWidth
                                      id="motivoConsulta"
                                      label="Motivo de Consulta"
                                      name="motivoConsulta"
                                      value={val.motivoConsulta}
                                      onChange={(e) => handleChangeInput(e, i)}
                                      onKeyDown={(e) =>
                                        e.code === "Enter" && data.length < 5
                                          ? handleClick(e, i)
                                          : null
                                      }
                                      error={
                                        !!errors.motivoConsulta &&
                                        !val.motivoConsulta.trim()
                                      }
                                      helperText={
                                        !!errors.motivoConsulta &&
                                        !val.motivoConsulta.trim()
                                          ? "No puede estar vacío"
                                          : ""
                                      }
                                    />
                                  </Grid>
                                  <Grid item xs={2} sm={1}>
                                    <Tooltip title="Eliminar">
                                      <IconButton
                                        aria-label="delete"
                                        size="large"
                                        color="error"
                                        hidden={
                                          data[0].motivoConsulta === "" ||
                                          data.length === 1
                                        }
                                        onClick={() => handleDelete(i)}
                                      >
                                        <DeleteIcon fontSize="inherit" />
                                      </IconButton>
                                    </Tooltip>
                                  </Grid>
                                </Grid>
                              </div>
                            ))}
                            <Grid container>
                              <Grid item xs={12} sm={3} sx={{ mt: 3 }}>
                                <Button
                                  variant="contained"
                                  disabled={activar}
                                  sx={{
                                    bgcolor: "teal",
                                    color: "white",
                                    borderRadius: 2,
                                  }}
                                  fullWidth
                                  onClick={handleClick}
                                  hidden={data.length === 5}
                                >
                                  Añadir Más
                                </Button>
                              </Grid>
                            </Grid>
                          </Item>
                          <Item sx={{ width: "100%" }}>
                            <DiagnosticosV2
                              value={diagnosticos}
                              onChange={(nextDiagnosticos) => {
                                setDiagnosticos(nextDiagnosticos);
                                clearError("diagnostico");
                              }}
                              error={errors.diagnostico}
                            />
                          </Item>
                        </Box>
                      </div>
                      <div style={{ width: "100%" }}>
                        <Item sx={{ width: "100%" }}>
                          <GruposEnfermedadV2 diagnosticos={diagnosticos} />
                        </Item>
                      </div>
                      <div style={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: isSmallScreen ? "column" : "row",
                          }}
                        >
                          <Item sx={{ width: "100%" }}>
                            <div>
                              <Grid
                                container
                                spacing={2}
                                sx={{ mt: !isSmallScreen ? 1 : 0 }}
                              >
                                <Grid item xs={12} sm={10}>
                                  <Autocomplete
                                    multiple
                                    fullWidth
                                    name="tratamiento"
                                    value={tratamiento}
                                    onChange={(e, newValue) => {
                                      setTratamiento(newValue);
                                      if (newValue.length > 0)
                                        clearError("tratamiento");
                                    }}
                                    inputValue={inputTratamiento}
                                    onInputChange={(e, newInputValue) => {
                                      setInputTratamiento(newInputValue);
                                    }}
                                    options={medicamentos}
                                    getOptionLabel={(option) => option.descripcion || ""}
                                    isOptionEqualToValue={(option, selected) =>
                                      String(option.medicamentoId) === String(selected.medicamentoId)
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Tratamiento"
                                        fullWidth
                                        error={!!errors.tratamiento}
                                        helperText={errors.tratamiento}
                                      />
                                    )}
                                  />
                                </Grid>
                              </Grid>
                            </div>
                            <br />
                          </Item>
                        </Box>
                      </div>
                      <Divider sx={{ mt: 4, mb: 3 }}>
                        <Chip label="ADICIONALES" />
                      </Divider>
                      <Grid container spacing={2} justifyContent="center">
                        <Grid item xs={12} sm={6}>
                          <Autocomplete
                            value={value}
                            onChange={(event, newValue) => {
                              setMedicoM5(newValue ? newValue.id : "");
                              setValue(newValue);
                              if (newValue) clearError("medico");
                            }}
                            inputValue={inputValue}
                            onInputChange={(event, newInputValue) => {
                              setInputValue(newInputValue);
                              if (newInputValue) clearError("medico");
                            }}
                            disablePortal
                            id="combo-box-demo"
                            options={usuarios}
                            getOptionLabel={(option) =>
                              option.nombreCompleto || ""
                            }
                            sx={{ width: "100%" }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Médico Responsable"
                                error={!!errors.medico}
                                helperText={errors.medico}
                              />
                            )}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            label="Comentarios"
                            value={comentAdicionales}
                            fullWidth
                            multiline
                            maxRows={4}
                            onChange={(event) =>
                              setValueCA(oracionFormato(event.target.value))
                            }
                          />
                        </Grid>
                      </Grid>
                      <Divider sx={{ mt: 5 }}></Divider>
                      <Grid
                        container
                        sx={{ mt: 2 }}
                        spacing={1}
                        justifyContent="center"
                      >
                        <Grid item sm={3} xs={6}>
                          <Button
                            variant="contained"
                            color="error"
                            size="large"
                            fullWidth
                            onClick={handleOpen}
                          >
                            Cancelar
                          </Button>
                        </Grid>
                        <Grid item sm={3} xs={6}>
                          <Button
                            type="submit"
                            variant="contained"
                            sx={{ bgcolor: "teal", color: "white" }}
                            size="large"
                            fullWidth
                            disabled={disableBtnSalud}
                          >
                            Guardar
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                slotProps={{ backdrop: { style: { opacity: 0.2 } } }}
              >
                <Box sx={style}>
                  <Typography
                    variant="h6"
                    className="text-center"
                    sx={{ mb: 1.5 }}
                  >
                    ¿Está seguro de cancelar esta operación?
                  </Typography>
                  <Divider sx={{ mt: 2 }} />
                  <Grid
                    container
                    sx={{ mt: 1 }}
                    spacing={1}
                    justifyContent="flex-end"
                  >
                    <Grid item>
                      <Button
                        variant="contained"
                        color="error"
                        onClick={handleClose}
                      >
                        No
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="contained"
                        sx={{ bgcolor: "teal", color: "white" }}
                        onClick={(event) =>
                          handleLinkCancelar(event, "cancelar")
                        }
                      >
                        Si
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Modal>
            </Container>
          </Box>
        </>
      ) : (
        <Restricted />
      )}
    </Box>
  );
};

export default EditarSaludV2;
